import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "manuals-panel" }
const _hoisted_2 = {
  key: 0,
  class: "manuals-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "manuals-empty"
}
const _hoisted_4 = {
  key: 2,
  class: "folder-grid"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "folder-body" }
const _hoisted_7 = { class: "folder-name" }
const _hoisted_8 = { class: "folder-count" }
const _hoisted_9 = { class: "folder-header" }
const _hoisted_10 = { class: "folder-title" }
const _hoisted_11 = { class: "folder-tabs" }
const _hoisted_12 = {
  key: 0,
  class: "folder-body-area"
}
const _hoisted_13 = { class: "manuals-actions" }
const _hoisted_14 = {
  key: 0,
  class: "manuals-loading"
}
const _hoisted_15 = {
  key: 1,
  class: "manuals-empty"
}
const _hoisted_16 = {
  key: 2,
  class: "manual-list"
}
const _hoisted_17 = { class: "manual-info" }
const _hoisted_18 = { class: "manual-name" }
const _hoisted_19 = { class: "manual-meta" }
const _hoisted_20 = ["title"]
const _hoisted_21 = {
  key: 1,
  class: "scan-tag",
  title: "PDF escaneado — sem camada de texto"
}
const _hoisted_22 = { class: "manual-meta manual-meta--sub" }
const _hoisted_23 = { class: "manual-actions" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "estagiario-result" }
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = {
  key: 1,
  class: "duvidas-area"
}
const _hoisted_31 = {
  key: 0,
  class: "manuals-empty"
}
const _hoisted_32 = {
  key: 0,
  class: "duvidas-manual-picker"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  ref: "chatScroll",
  class: "chat-messages"
}
const _hoisted_35 = {
  key: 0,
  class: "chat-hero"
}
const _hoisted_36 = { class: "chat-hero-sub" }
const _hoisted_37 = { class: "chat-bubble" }
const _hoisted_38 = {
  key: 1,
  class: "chat-msg chat-msg--ia"
}
const _hoisted_39 = { class: "chat-input-bar" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 1,
  class: "chat-error"
}
const _hoisted_43 = {
  key: 2,
  class: "modal-backdrop"
}
const _hoisted_44 = { class: "modal-card" }
const _hoisted_45 = { class: "mf-field" }
const _hoisted_46 = { class: "mf-field" }
const _hoisted_47 = {
  key: 0,
  class: "mf-hint"
}
const _hoisted_48 = {
  key: 0,
  class: "mf-hint-compress"
}
const _hoisted_49 = { class: "mf-field" }
const _hoisted_50 = { class: "project-checks" }
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  class: "modal-error"
}
const _hoisted_53 = {
  key: 1,
  class: "mf-compress-status"
}
const _hoisted_54 = { class: "modal-actions" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "modal-card" }
const _hoisted_57 = { class: "mf-field" }
const _hoisted_58 = { class: "mf-field" }
const _hoisted_59 = { class: "project-checks" }
const _hoisted_60 = ["value"]
const _hoisted_61 = {
  key: 0,
  class: "modal-error"
}
const _hoisted_62 = { class: "modal-actions" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 4,
  class: "modal-backdrop modal-backdrop--ia"
}
const _hoisted_65 = { class: "modal-card modal-card--wide" }
const _hoisted_66 = { class: "preview-sub" }
const _hoisted_67 = {
  key: 0,
  class: "preview-truncated"
}
const _hoisted_68 = { class: "preview-groups" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["title", "onClick"]
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = { class: "pg-count" }
const _hoisted_73 = { class: "pg-peri" }
const _hoisted_74 = {
  key: 0,
  class: "pg-need-resp",
  title: "Expanda para escolher os responsáveis"
}
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "pg-resp" }
const _hoisted_77 = { class: "pg-resp-chips" }
const _hoisted_78 = ["value", "onUpdate:modelValue"]
const _hoisted_79 = {
  key: 0,
  class: "pg-resp-warn"
}
const _hoisted_80 = { class: "pr-head" }
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = {
  key: 0,
  class: "pr-page"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = {
  key: 0,
  class: "pr-checklist"
}
const _hoisted_86 = { class: "pr-check-list" }
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "pr-types" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 0,
  class: "pr-sugg"
}
const _hoisted_92 = {
  key: 1,
  class: "modal-error"
}
const _hoisted_93 = { class: "modal-actions" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 0,
  class: "manuals-toast"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.selectedProject)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "manuals-header" }, [
            _createElementVNode("h2", { class: "manuals-title" }, [
              _createTextVNode("Manuais "),
              _createElementVNode("span", { class: "beta-tag" }, "Beta")
            ]),
            _createElementVNode("p", { class: "manuals-subtitle" }, "Manuais de operação e manutenção em PDF, organizados por obra. O EstagIArio Joe pode interpretar rotinas e responder dúvidas.")
          ], -1)),
          (_ctx.loadingProjects)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando projetos..."))
            : (_ctx.projects.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nenhum projeto cadastrado."))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: proj.id,
                      class: "folder-card",
                      type: "button",
                      onClick: ($event: any) => (_ctx.openFolder(proj))
                    }, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "folder-icon" }, [
                        _createElementVNode("svg", {
                          width: "34",
                          height: "34",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.6"
                        }, [
                          _createElementVNode("path", { d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" })
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(proj.name), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.manualCountFor(proj.id)) + " " + _toDisplayString(_ctx.manualCountFor(proj.id) === 1 ? 'manual' : 'manuais'), 1)
                      ])
                    ], 8, _hoisted_5))
                  }), 128))
                ]))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "folder-back",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeFolder && _ctx.closeFolder(...args)))
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
              ], -1),
              _createTextVNode(" Voltar ", -1)
            ]))]),
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.selectedProject.name), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass(["folder-tab", { active: _ctx.activeTab === 'manuais' }]),
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'manuais'))
            }, "Manuais", 2),
            (_ctx.aiEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["folder-tab folder-tab--ia", { active: _ctx.activeTab === 'duvidas' }]),
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openDuvidas && _ctx.openDuvidas(...args)))
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "17",
                      x2: "12.01",
                      y2: "17"
                    })
                  ], -1),
                  _createTextVNode(" Alguma dúvida? ", -1)
                ]))], 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.activeTab === 'manuais')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btn-upload",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openUploadModal && _ctx.openUploadModal(...args)))
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("svg", {
                      width: "15",
                      height: "15",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                      _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "3",
                        x2: "12",
                        y2: "15"
                      })
                    ], -1),
                    _createTextVNode(" Enviar manual (PDF) ", -1)
                  ]))])
                ]),
                (_ctx.manualsStore.state.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Carregando manuais..."))
                  : (_ctx.folderManuals.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Nenhum manual nesta obra ainda. Envie o manual de operação e manutenção da atração em PDF. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folderManuals, (manual) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: manual.id,
                            class: "manual-card"
                          }, [
                            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "manual-icon" }, [
                              _createElementVNode("svg", {
                                width: "22",
                                height: "22",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.6"
                              }, [
                                _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                              ])
                            ], -1)),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(manual.name), 1),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", null, _toDisplayString(manual.pageCount || '?') + " pág.", 1),
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "meta-sep" }, "·", -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatSize(manual.sizeBytes)), 1),
                                (manual.originalSizeBytes > manual.sizeBytes)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "compressed-tag",
                                      title: `Original: ${_ctx.formatSize(manual.originalSizeBytes)}`
                                    }, "comprimido", 8, _hoisted_20))
                                  : _createCommentVNode("", true),
                                (!manual.textOk)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "escaneado"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_22, " Enviado por " + _toDisplayString(manual.uploadedBy) + " em " + _toDisplayString(_ctx.formatDate(manual.createdAt)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                class: "m-act",
                                type: "button",
                                title: "Ver PDF",
                                onClick: ($event: any) => (_ctx.viewPdf(manual))
                              }, [...(_cache[28] || (_cache[28] = [
                                _createElementVNode("svg", {
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
                                  _createElementVNode("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "3"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_24),
                              _createElementVNode("button", {
                                class: "m-act",
                                type: "button",
                                title: "Editar",
                                onClick: ($event: any) => (_ctx.openEditModal(manual))
                              }, [...(_cache[29] || (_cache[29] = [
                                _createElementVNode("svg", {
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                                  _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                                ], -1)
                              ]))], 8, _hoisted_25),
                              _createElementVNode("button", {
                                class: "m-act m-act--danger",
                                type: "button",
                                title: "Excluir",
                                onClick: ($event: any) => (_ctx.askRemove(manual))
                              }, [...(_cache[30] || (_cache[30] = [
                                _createElementVNode("svg", {
                                  width: "15",
                                  height: "15",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                                  _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                                ], -1)
                              ]))], 8, _hoisted_26),
                              (_ctx.aiEnabled && _ctx.extractionFor(manual))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2.4"
                                      }, [
                                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                                      ], -1)),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.extractionFor(manual)!.count) + " rotina" + _toDisplayString(_ctx.extractionFor(manual)!.count !== 1 ? 's' : '') + " criada" + _toDisplayString(_ctx.extractionFor(manual)!.count !== 1 ? 's' : '') + " pelo estagiário em " + _toDisplayString(_ctx.formatDate(_ctx.extractionFor(manual)!.at)), 1)
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn-ver-rotinas",
                                      type: "button",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToRoutines && _ctx.goToRoutines(...args)))
                                    }, "Ver rotinas"),
                                    _createElementVNode("button", {
                                      class: "btn-reenviar",
                                      type: "button",
                                      disabled: _ctx.extracting,
                                      title: "Interpretar o manual novamente (cria rotinas adicionais)",
                                      onClick: ($event: any) => (_ctx.sendToEstagiario(manual))
                                    }, "reenviar", 8, _hoisted_28)
                                  ], 64))
                                : (_ctx.aiEnabled)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn-estagiario",
                                      type: "button",
                                      disabled: _ctx.extracting,
                                      onClick: ($event: any) => (_ctx.sendToEstagiario(manual))
                                    }, [...(_cache[32] || (_cache[32] = [
                                      _createElementVNode("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2"
                                      }, [
                                        _createElementVNode("path", { d: "M12 2L2 7l10 5 10-5-10-5z" }),
                                        _createElementVNode("path", { d: "M2 17l10 5 10-5" }),
                                        _createElementVNode("path", { d: "M2 12l10 5 10-5" })
                                      ], -1),
                                      _createTextVNode(" Enviar para o estagiário ", -1)
                                    ]))], 8, _hoisted_29))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
              ]))
            : (_ctx.activeTab === 'duvidas')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_ctx.folderManuals.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Envie um manual primeiro para tirar dúvidas."))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.folderManuals.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "picker-label" }, "Manual:", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folderManuals, (m) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: m.id,
                                  class: _normalizeClass(["picker-chip", { active: _ctx.chatManualId === m.id }]),
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.switchChatManual(m.id))
                                }, _toDisplayString(m.name), 11, _hoisted_33))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                          (_ctx.chatMessages.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "chat-hero-icon" }, [
                                  _createElementVNode("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.6"
                                  }, [
                                    _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                                  ])
                                ], -1)),
                                _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "chat-hero-title" }, "O que você quer saber?", -1)),
                                _createElementVNode("p", _hoisted_36, "Pergunte qualquer coisa sobre o manual \"" + _toDisplayString(_ctx.chatManualName) + "\" — o EstagIArio Joe caça a resposta e cita a página.", 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatMessages, (msg, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: _normalizeClass(["chat-msg", msg.role === 'user' ? 'chat-msg--user' : 'chat-msg--ia'])
                            }, [
                              _createElementVNode("div", _hoisted_37, _toDisplayString(msg.text), 1)
                            ], 2))
                          }), 128)),
                          (_ctx.chatLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("div", { class: "chat-bubble chat-bubble--typing" }, [
                                  _createElementVNode("span"),
                                  _createElementVNode("span"),
                                  _createElementVNode("span")
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 512),
                        _createElementVNode("div", _hoisted_39, [
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chatInput) = $event)),
                            class: "chat-textarea",
                            rows: "1",
                            placeholder: "Ex: qual o torque dos parafusos do braço principal?",
                            disabled: _ctx.chatLoading,
                            onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendQuestion && _ctx.sendQuestion(...args)), ["exact","prevent"]), ["enter"]))
                          }, null, 40, _hoisted_40), [
                            [_vModelText, _ctx.chatInput]
                          ]),
                          _createElementVNode("button", {
                            class: "chat-send",
                            type: "button",
                            disabled: _ctx.chatLoading || !_ctx.chatInput.trim(),
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendQuestion && _ctx.sendQuestion(...args)))
                          }, [...(_cache[38] || (_cache[38] = [
                            _createElementVNode("svg", {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2"
                            }, [
                              _createElementVNode("line", {
                                x1: "22",
                                y1: "2",
                                x2: "11",
                                y2: "13"
                              }),
                              _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                            ], -1)
                          ]))], 8, _hoisted_41)
                        ]),
                        (_ctx.chatError)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.chatError), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                ]))
              : _createCommentVNode("", true)
        ], 64)),
    (_ctx.showUpload)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "modal-title" }, "Enviar manual (PDF)", -1)),
            _createElementVNode("div", _hoisted_45, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "mf-label" }, "Nome do manual", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploadName) = $event)),
                class: "mf-input",
                type: "text",
                placeholder: "Ex: Manual O&M — Roda Gigante XYZ"
              }, null, 512), [
                [_vModelText, _ctx.uploadName]
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "mf-label" }, "Arquivo PDF (máx. 100MB)", -1)),
              _createElementVNode("input", {
                ref: "fileInput",
                class: "mf-file",
                type: "file",
                accept: "application/pdf,.pdf",
                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFilePick && _ctx.onFilePick(...args)))
              }, null, 544),
              (_ctx.uploadFile)
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
                    _createTextVNode(_toDisplayString(_ctx.uploadFile.name) + " — " + _toDisplayString(_ctx.formatSize(_ctx.uploadFile.size)) + " ", 1),
                    (_ctx.uploadFile.size > _ctx.COMPRESS_TARGET_BYTES)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, "· será comprimido para até 40MB antes do envio"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "mf-label" }, "Obras vinculadas", -1)),
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: proj.id,
                    class: "project-check"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: proj.id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uploadProjectIds) = $event))
                    }, null, 8, _hoisted_51), [
                      [_vModelCheckbox, _ctx.uploadProjectIds]
                    ]),
                    _createTextVNode(" " + _toDisplayString(proj.name), 1)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.uploadError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.uploadError), 1))
              : _createCommentVNode("", true),
            (_ctx.uploading && _ctx.compressStatus)
              ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "mf-compress-spinner" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.compressStatus), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "btn-secondary",
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cancelOrClose && _ctx.cancelOrClose(...args)))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                disabled: _ctx.uploading || !_ctx.uploadFile || _ctx.uploadProjectIds.length === 0,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.doUpload && _ctx.doUpload(...args)))
              }, _toDisplayString(_ctx.uploading ? 'Processando...' : 'Enviar'), 9, _hoisted_55)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.editingManual)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-backdrop",
          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.editingManual = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_56, [
            _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "modal-title" }, "Editar manual", -1)),
            _createElementVNode("div", _hoisted_57, [
              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "mf-label" }, "Nome", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editName) = $event)),
                class: "mf-input",
                type: "text"
              }, null, 512), [
                [_vModelText, _ctx.editName]
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "mf-label" }, "Obras vinculadas", -1)),
              _createElementVNode("div", _hoisted_59, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (proj) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: proj.id,
                    class: "project-check"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: proj.id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editProjectIds) = $event))
                    }, null, 8, _hoisted_60), [
                      [_vModelCheckbox, _ctx.editProjectIds]
                    ]),
                    _createTextVNode(" " + _toDisplayString(proj.name), 1)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.editError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_ctx.editError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                class: "btn-secondary",
                type: "button",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editingManual = null))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                disabled: _ctx.editProjectIds.length === 0,
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)))
              }, "Salvar", 8, _hoisted_63)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.extracting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [...(_cache[47] || (_cache[47] = [
          _createElementVNode("div", { class: "extract-loading" }, [
            _createElementVNode("div", { class: "extract-spinner" }),
            _createElementVNode("h3", { class: "extract-loading-title" }, "O EstagIArio Joe está lendo o manual..."),
            _createElementVNode("p", { class: "extract-loading-sub" }, "Interpretando rotinas de manutenção, periodicidades e checklists. Em manuais grandes isso pode levar alguns minutos.")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.extractPreview)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "modal-backdrop",
          onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.askClosePreview && _ctx.askClosePreview(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_65, [
            _cache[56] || (_cache[56] = _createStaticVNode("<h3 class=\"modal-title modal-title--ia\" data-v-3f69ce7d><svg width=\"17\" height=\"17\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-3f69ce7d><path d=\"M12 2L2 7l10 5 10-5-10-5z\" data-v-3f69ce7d></path><path d=\"M2 17l10 5 10-5\" data-v-3f69ce7d></path><path d=\"M2 12l10 5 10-5\" data-v-3f69ce7d></path></svg> Rotinas encontradas no manual </h3>", 1)),
            _createElementVNode("p", _hoisted_66, [
              _cache[48] || (_cache[48] = _createTextVNode("Revise, ajuste os responsáveis de cada grupo e salve. As rotinas serão criadas em ", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.selectedProject?.name), 1),
              _cache[49] || (_cache[49] = _createTextVNode(".", -1))
            ]),
            (_ctx.extractPreview.truncated)
              ? (_openBlock(), _createElementBlock("p", _hoisted_67, " Este manual é muito extenso — o estagiário pode não ter conseguido ler até o final. As rotinas abaixo são válidas, mas confira se falta algo das últimas seções do manual. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_68, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extractPreview.grupos, (grupo, gi) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: gi,
                  class: _normalizeClass(["preview-group", { 'preview-group--open': _ctx.groupExpanded[gi] }])
                }, [
                  _createElementVNode("div", {
                    class: "pg-header pg-header--clickable",
                    onClick: ($event: any) => (_ctx.toggleGroup(gi))
                  }, [
                    _createElementVNode("button", {
                      class: "pg-chevron",
                      type: "button",
                      title: _ctx.groupExpanded[gi] ? 'Minimizar' : 'Expandir',
                      onClick: _withModifiers(($event: any) => (_ctx.toggleGroup(gi)), ["stop"])
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass({ open: _ctx.groupExpanded[gi] }),
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [...(_cache[50] || (_cache[50] = [
                        _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                      ]))], 2))
                    ], 8, _hoisted_70),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((grupo.nome) = $event),
                      class: "pg-name-input",
                      type: "text",
                      onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                    }, null, 8, _hoisted_71), [
                      [_vModelText, grupo.nome]
                    ]),
                    _createElementVNode("span", _hoisted_72, _toDisplayString(grupo.rotinas.length) + " rotina" + _toDisplayString(grupo.rotinas.length !== 1 ? 's' : ''), 1),
                    _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.periLabel(grupo.periodicidade)), 1),
                    (!(_ctx.groupResponsaveis[gi] && _ctx.groupResponsaveis[gi].length))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_74, "sem responsável"))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "pg-remove",
                      type: "button",
                      title: "Remover grupo",
                      onClick: _withModifiers(($event: any) => (_ctx.removeGroup(gi)), ["stop"])
                    }, [...(_cache[51] || (_cache[51] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1)
                    ]))], 8, _hoisted_75)
                  ], 8, _hoisted_69),
                  (_ctx.groupExpanded[gi])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_76, [
                          _cache[52] || (_cache[52] = _createElementVNode("span", { class: "pg-resp-label" }, "Responsáveis:", -1)),
                          _createElementVNode("div", _hoisted_77, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: acc.username,
                                class: _normalizeClass(["resp-chip", { active: _ctx.groupResponsaveis[gi]?.includes(acc.username) }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: acc.username,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.groupResponsaveis[gi]) = $event),
                                  style: {"display":"none"}
                                }, null, 8, _hoisted_78), [
                                  [_vModelCheckbox, _ctx.groupResponsaveis[gi]]
                                ]),
                                _createTextVNode(" " + _toDisplayString(acc.name || acc.username), 1)
                              ], 2))
                            }), 128))
                          ]),
                          (!_ctx.groupResponsaveis[gi] || _ctx.groupResponsaveis[gi].length === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_79, "Selecione ao menos um responsável."))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.rotinas, (rotina, ri) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: ri,
                            class: "preview-rotina"
                          }, [
                            _createElementVNode("div", _hoisted_80, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((rotina.nome) = $event),
                                class: "pr-name-input",
                                type: "text"
                              }, null, 8, _hoisted_81), [
                                [_vModelText, rotina.nome]
                              ]),
                              (rotina.paginaReferencia)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_82, "pág. " + _toDisplayString(rotina.paginaReferencia), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "pg-remove",
                                type: "button",
                                title: "Remover rotina",
                                onClick: ($event: any) => (grupo.rotinas.splice(ri, 1))
                              }, [...(_cache[53] || (_cache[53] = [
                                _createElementVNode("svg", {
                                  width: "13",
                                  height: "13",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_83)
                            ]),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((rotina.descricao) = $event),
                              class: "pr-desc",
                              rows: "2",
                              placeholder: "Descrição do procedimento"
                            }, null, 8, _hoisted_84), [
                              [_vModelText, rotina.descricao]
                            ]),
                            (rotina.checklist.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _cache[54] || (_cache[54] = _createElementVNode("div", { class: "pr-check-title" }, "Checklist:", -1)),
                                  _createElementVNode("ul", _hoisted_86, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rotina.checklist, (item, ci) => {
                                      return (_openBlock(), _createElementBlock("li", { key: ci }, [
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": ($event: any) => ((rotina.checklist[ci]) = $event),
                                          class: "pr-check-input",
                                          type: "text"
                                        }, null, 8, _hoisted_87), [
                                          [_vModelText, rotina.checklist[ci]]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "pr-check-x",
                                          type: "button",
                                          onClick: ($event: any) => (rotina.checklist.splice(ci, 1))
                                        }, "×", 8, _hoisted_88)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_89, [
                              _cache[55] || (_cache[55] = _createElementVNode("span", { class: "pr-types-label" }, "Resposta:", -1)),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList((['check', 'texto', 'foto'] as const), (t) => {
                                return _createElementVNode("button", {
                                  key: t,
                                  class: _normalizeClass(["type-chip", { active: rotina.responseTypes.includes(t) }]),
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.toggleType(rotina, t))
                                }, _toDisplayString(t === 'check' ? 'Check' : t === 'texto' ? 'Texto' : 'Foto'), 11, _hoisted_90)
                              }), 64)),
                              (rotina.responsavelSugerido)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Sugestão do manual: " + _toDisplayString(rotina.responsavelSugerido), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            (_ctx.saveError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString(_ctx.saveError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("button", {
                class: "btn-secondary",
                type: "button",
                disabled: _ctx.savingRoutines,
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.askClosePreview && _ctx.askClosePreview(...args)))
              }, "Descartar", 8, _hoisted_94),
              _createElementVNode("button", {
                class: "btn-primary btn-primary--ia",
                type: "button",
                disabled: _ctx.savingRoutines || !_ctx.canSavePreview,
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.savePreview && _ctx.savePreview(...args)))
              }, _toDisplayString(_ctx.savingRoutines ? 'Criando rotinas...' : `Salvar ${_ctx.totalPreviewRoutines} rotina${_ctx.totalPreviewRoutines !== 1 ? 's' : ''}`), 9, _hoisted_95)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "toast-fade" }, {
      default: _withCtx(() => [
        (_ctx.toast)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.toast), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}